import React, { useEffect, useState } from 'react'
import Table from 'react-bootstrap/Table'
import api from '../components/api'
import { Link } from 'react-router-dom'

import { useEnunciadoContext } from '../context/enunciadoContext'
import { useVerificaDesafioContext } from '../context/verificaDesafioContext'
import { useSecaoEnunciadoContext } from '../context/secaoEnunciadoContext'

import StatusValidacaoSecao from './StatusValidacaoSecao'


const GestaoEficiencia = (props) => {

    var ano = props.ano
    var adesao_institucional_id = props.adesao_institucional_id
    

    
    var { enunciado, setEnunciado } = useEnunciadoContext()
    var { setSecaoEnunciado } = useSecaoEnunciadoContext()
    var { verificaDesafio } = useVerificaDesafioContext()


    const [questao1, setQuestao1] = useState()
    const [questao2, setQuestao2] = useState()
    const [questao3, setQuestao3] = useState()
    const [questao4, setQuestao4] = useState()
    const [questao5, setQuestao5] = useState()
    const [questao6, setQuestao6] = useState()
    const [questao7, setQuestao7] = useState()


    const [totalPendencias, setTotalPendencias] = useState(0)


    var [energia_id, setEnergia_id] = useState()    
    const [energiaGestaoEficiencia_id, setEnergiaGestaoEficiencia_id] = useState()
    const [quemCuidaRefrigeraClima, setQuemCuidaRefrigeraClima] = useState('')
    const [gestaoEnergia, setGestaoEnergia] = useState('')
    const [quemFazGestao, setQuemFazGestao] = useState('')
    const [politicaEficiencia, setPoliticaEficiencia] = useState('')

    const [engajamentoColaboradores, setEngajamentoColaboradores] = useState(false)
    const [auditoriasEnergeticas, setAuditoriasEnergeticas] = useState(false)

    const [substituicaoLampadas, setSubstituicaoLampadas] = useState('')
    const [iluminacaoInteligente, setIluminacaoInteligente] = useState('')
    const [retrofit, setRetrofit] = useState('')
    const [conservacaoEnergia, setConservacaoEnergia] = useState('')
    const [adocaoPoliticas, setAdocaoPoliticas] = useState('')
    const [investimentoAutogeracao, setInvestimentoAutogeracao] = useState('')
    const [gerenciamentoDemanda, setGerenciamentoDemanda] = useState('')
    const [tecnologiasCogeracao, setTecnologiasCogeracao] = useState('')
    const [consultoriasEspecializadas, setConsultoriasEspecializadas] = useState('')
    const [implementacaoSistemas, setImplementacaoSistemas] = useState('')
    const [outras, setOutras] = useState('')
    const [outrasEspecifique, setOutrasEspecifique] = useState('')



    const [baixaRelevancia, setBaixaRelevancia] = useState('')
    const [resistenciaInvestir, setResistenciaInvestir] = useState('')
    const [limitacaoInvestimento, setLimitacaoInvestimento] = useState('')
    const [ausenciaTime, setAusenciaTime] = useState('')
    const [faltaConhecimento, setFaltaConhecimento] = useState('')
    const [dificuldadeDefinicao, setDificuldadeDefinicao] = useState('')
    const [barreirasOperacionais, setBarreirasOperacionais] = useState('')
    const [investimentoInicial, setInvestimentoInicial] = useState('')
    const [baixaPercepcao, setBaixaPercepcao] = useState('')
    const [baixaAdesao, setBaixaAdesao] = useState('')
    const [receioInfringir, setReceioInfringir] = useState('')
    const [dificuldadesLicitatorias, setDificuldadesLicitatorias] = useState('')
    const [dificuldadeSelecao, setDificuldadeSelecao] = useState('')
    const [medidasEficienciaBaixoInvestimento, setMedidasEficienciaBaixoInvestimento] = useState('')
    const [medidasEficienciaMedioInvestimento, setMedidasEficienciaMedioInvestimento] = useState('')
    const [medidasEficienciaAltoInvestimento, setMedidasEficienciaAltoInvestimento] = useState('')
    const [implementacaoSolucoes, setImplementacaoSolucoes] = useState('')

    const [implementacaoPolitica, setImplementacaoPolitica] = useState('')
    const [contratacaoConsultoria, setContratacaoConsultoria] = useState('')
    const [programaComContrapartida, setProgramaComContrapartida] = useState('')
    const [programaSemContrapartida, setProgramaSemContrapartida] = useState('')
    const [programaCompras, setProgramaCompras] = useState('')
    const [terceirizacaoResp, setTerceirizacaoResp] = useState('')
    const [iso50001, setIso50001] = useState('')
    const [adocaoRDC, setAdocaoRDC] = useState('')

    const [contratacaoEspecialista, setContratacaoEspecialista] = useState('')
    const [capacitacaoEquipe, setCapacitacaoEquipe] = useState('')





    useEffect(() => {

        verificaValidacoes()


    }, [energia_id, verificaDesafio])


    const verificaValidacoes = () => {

        //console.log('verificado', energia_id)

        setQuestao1()
        setQuestao2()
        setQuestao3()
        setQuestao4()
        setQuestao5()
        setQuestao6()
        setQuestao7()
        

        if (energia_id) {

            var dataPost = {

                formulario_id: energia_id,
                desafio: 'Energia',

            }

            

            api.post('desafioValidaVarios', dataPost).then((result) => {

                
                var data = result.data
                console.log(data)
                var totalErros = 0

                for (var k = 0; k < data.length; k++) {

                    if (data[k].status == 'Erro') {


                        switch (data[k].enunciado) {

                            case '1. Quem cuida da refrigeração e climatização?':

                                totalErros = totalErros + 1
                                setQuestao1('red')
    
                            break

                            case '2. Como é a gestão de energia (energia elétrica e outras formas) na sua organização?':
                                
                                totalErros = totalErros + 1
                                setQuestao2('red')
    
                            break


                            case '3. Quem faz essa gestão?':

                                totalErros = totalErros + 1
                                setQuestao3('red')
    
                            break

                            case '4. Existem uma Política de eficiência energética na instituição?':

                                totalErros = totalErros + 1
                                setQuestao4('red')
    
                            break

                            case '5. Quais das seguintes medidas de eficiência energética estão em prática em sua instituição? Selecione todas que se aplicam.':

                                totalErros = totalErros + 1
                                setQuestao5('red')
    
                            break

                            case '6. Quais são os maiores desafios para implementar ações de eficiência energética?':

                                totalErros = totalErros + 1
                                setQuestao6('red')
    
                            break

                            case '7. Qual é o interesse da organização em implementar diferentes ações de eficiência energética?':

                                totalErros = totalErros + 1
                                setQuestao7('red')
    
                            break
                            
                        }

                    }

                    

                }

                setTotalPendencias(totalErros)

            }).catch((err) => {

                console.log(err.response)

            })

        }


    }



    

    const salvaEnergia = () => {


        var dataPost = {

            quemCuidaRefrigeraClima: quemCuidaRefrigeraClima,
            gestaoEnergia: gestaoEnergia,
            quemFazGestao: quemFazGestao,
            politicaEficiencia: politicaEficiencia,

            engajamentoColaboradores: engajamentoColaboradores,
            auditoriasEnergeticas: auditoriasEnergeticas,

            substituicaoLampadas: substituicaoLampadas,
            iluminacaoInteligente: iluminacaoInteligente,
            retrofit: retrofit,
            conservacaoEnergia: conservacaoEnergia,
            adocaoPoliticas: adocaoPoliticas,
            investimentoAutogeracao: investimentoAutogeracao,
            gerenciamentoDemanda: gerenciamentoDemanda,
            tecnologiasCogeracao: tecnologiasCogeracao,
            consultoriasEspecializadas: consultoriasEspecializadas,
            implementacaoSistemas: implementacaoSistemas,
            outras: outras,
            outrasEspecifique: outrasEspecifique,

            baixaRelevancia: baixaRelevancia,
            resistenciaInvestir: resistenciaInvestir,
            limitacaoInvestimento: limitacaoInvestimento,
            ausenciaTime: ausenciaTime,
            faltaConhecimento: faltaConhecimento,
            dificuldadeDefinicao: dificuldadeDefinicao,
            barreirasOperacionais: barreirasOperacionais,
            investimentoInicial: investimentoInicial,
            baixaPercepcao: baixaPercepcao,
            baixaAdesao: baixaAdesao,
            receioInfringir: receioInfringir,
            dificuldadesLicitatorias: dificuldadesLicitatorias,
            dificuldadeSelecao: dificuldadeSelecao,
            medidasEficienciaBaixoInvestimento: medidasEficienciaBaixoInvestimento,
            medidasEficienciaMedioInvestimento: medidasEficienciaMedioInvestimento,
            medidasEficienciaAltoInvestimento: medidasEficienciaAltoInvestimento,
            implementacaoSolucoes: implementacaoSolucoes,

            capacitacaoEquipe: capacitacaoEquipe,

            contratacaoEspecialista: contratacaoEspecialista,
            implementacaoPolitica: implementacaoPolitica,
            contratacaoConsultoria: contratacaoConsultoria,
            programaComContrapartida: programaComContrapartida,
            programaSemContrapartida: programaSemContrapartida,
            programaCompras: programaCompras,
            terceirizacaoResp: terceirizacaoResp,
            iso50001: iso50001,
            adocaoRDC: adocaoRDC,

        }

        //console.log(dataPost)




        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'green',
		    title: 'Confirmação',
		    content: 'Confirma os dados?',
		    buttons: {
		        Sim: function () {

                    if (energiaGestaoEficiencia_id) {


                        api.put(`energiaEficiencia/${energia_id}`, dataPost).then((result) => {

                            console.log(result.data)
                            window.toastr.success('Registro salvo com sucesso!')
                            //setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))

                        }).catch((err) => {

                            console.log(err.response)

                        })


                    } else {

                        api.post(`energiaEficiencia/${adesao_institucional_id}/${ano}`, dataPost).then((result) => {

                            //console.log(result.data[0].perfilAnual_id, '!!')
                            console.log(result.data)
                            setEnergia_id(result.data.energia_id)
                            window.toastr.success('Registro salvo com sucesso!')
                            //history.push('/Obrigado')
                            //setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))

                
                        }).catch((err) => {
                
                            console.log(err.response)
                
                        })

                    }

                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });

    }


    const carregaDados = () => {

        if (adesao_institucional_id && ano) {

            
            api.get(`energiaEficiencia/${adesao_institucional_id}/${ano}`).then((result) => {
                
                //console.log(result.data, '!!')
                //console.log(`energiaEficiencia/${adesao_institucional_id}/${ano}`)
                var data = result.data[0]

                setEnergia_id(data.energia_id)
                setEnergiaGestaoEficiencia_id(data.energiaGestaoEficiencia_id)
                setQuemCuidaRefrigeraClima(data.quemCuidaRefrigeraClima)

                setGestaoEnergia(data.gestaoEnergia)
                setQuemFazGestao(data.quemFazGestao)
                setPoliticaEficiencia(data.politicaEficiencia)

                setEngajamentoColaboradores(data.engajamentoColaboradores)
                setAuditoriasEnergeticas(data.auditoriasEnergeticas)

                setSubstituicaoLampadas(data.substituicaoLampadas)
                setIluminacaoInteligente(data.iluminacaoInteligente)
                setRetrofit(data.retrofit)
                setConservacaoEnergia(data.conservacaoEnergia)
                setAdocaoPoliticas(data.adocaoPoliticas)
                setInvestimentoAutogeracao(data.investimentoAutogeracao)
                setGerenciamentoDemanda(data.gerenciamentoDemanda)
                setTecnologiasCogeracao(data.tecnologiasCogeracao)
                setConsultoriasEspecializadas(data.consultoriasEspecializadas)
                setImplementacaoSistemas(data.implementacaoSistemas)
                setOutras(data.outras)
                setOutrasEspecifique(data.outrasEspecifique)



                setBaixaRelevancia(data.baixaRelevancia)
                setResistenciaInvestir(data.resistenciaInvestir)
                setLimitacaoInvestimento(data.limitacaoInvestimento)
                setAusenciaTime(data.ausenciaTime)
                setFaltaConhecimento(data.faltaConhecimento)
                setDificuldadeDefinicao(data.dificuldadeDefinicao)
                setBarreirasOperacionais(data.barreirasOperacionais)
                setInvestimentoInicial(data.investimentoInicial)
                setBaixaPercepcao(data.baixaPercepcao)
                setBaixaAdesao(data.baixaAdesao)
                setReceioInfringir(data.receioInfringir)
                setDificuldadesLicitatorias(data.dificuldadesLicitatorias)
                setDificuldadeSelecao(data.dificuldadeSelecao)
                setMedidasEficienciaBaixoInvestimento(data.medidasEficienciaBaixoInvestimento)
                setMedidasEficienciaMedioInvestimento(data.medidasEficienciaMedioInvestimento)
                setMedidasEficienciaAltoInvestimento(data.medidasEficienciaAltoInvestimento)
                setImplementacaoSolucoes(data.implementacaoSolucoes)

                setImplementacaoPolitica(data.implementacaoPolitica)
                setContratacaoConsultoria(data.contratacaoConsultoria)
                setProgramaComContrapartida(data.programaComContrapartida)
                setProgramaSemContrapartida(data.programaSemContrapartida)
                setProgramaCompras(data.programaCompras)
                setTerceirizacaoResp(data.terceirizacaoResp)
                setIso50001(data.iso50001)
                setAdocaoRDC(data.adocaoRDC)

                setContratacaoEspecialista(data.contratacaoEspecialista)
                setCapacitacaoEquipe(data.capacitacaoEquipe)


            }).catch((err) => {

                console.log(err.response)

            })

        }


    }

    const limpa = () => {

        setEnergia_id()
        setQuemCuidaRefrigeraClima('')

        setGestaoEnergia('')
        setQuemFazGestao('')
        setPoliticaEficiencia('')

        setEngajamentoColaboradores(false)
        setAuditoriasEnergeticas(false)

        setSubstituicaoLampadas('')
        setIluminacaoInteligente('')
        setRetrofit('')
        setConservacaoEnergia('')
        setAdocaoPoliticas('')
        setInvestimentoAutogeracao('')
        setGerenciamentoDemanda('')
        setTecnologiasCogeracao('')
        setConsultoriasEspecializadas('')
        setImplementacaoSistemas('')
        setOutras('')
        setOutrasEspecifique('')



        setBaixaRelevancia('')
        setResistenciaInvestir('')
        setLimitacaoInvestimento('')
        setAusenciaTime('')
        setFaltaConhecimento('')
        setDificuldadeDefinicao('')
        setBarreirasOperacionais('')
        setInvestimentoInicial('')
        setBaixaPercepcao('')
        setBaixaAdesao('')
        setReceioInfringir('')
        setDificuldadesLicitatorias('')
        setDificuldadeSelecao('')
        setMedidasEficienciaBaixoInvestimento('')
        setMedidasEficienciaMedioInvestimento('')
        setMedidasEficienciaAltoInvestimento('')
        setImplementacaoSolucoes('')

        setImplementacaoPolitica('')
        setContratacaoConsultoria('')
        setProgramaComContrapartida('')
        setProgramaSemContrapartida('')
        setProgramaCompras('')
        setTerceirizacaoResp('')
        setIso50001('')
        setAdocaoRDC('')

        setContratacaoEspecialista('')
        setCapacitacaoEquipe('')

    }


    const carregaId = () => {

        api.get(`energia/${adesao_institucional_id}/${ano}`).then((result) => {

            //console.log(result.data[0].energia_id)
            setEnergia_id(result.data[0].energia_id)

        }).catch((err) => {

            console.log(err.response)

        })

    }


    useEffect(() => {
        
        limpa()
        carregaId()
        carregaDados()


    }, [ano, adesao_institucional_id])



    return (

        <div>

                        <Table striped bordered hover>
                            
                            <tbody>
                                <tr>
                                    <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                                    <Link to='#' style={{ color: questao1 }} onClick={() => {setEnunciado('1. Quem cuida da refrigeração e climatização?');setSecaoEnunciado('Gestão de Energia & Eficiência Energética');window.$('#modalValidacao').modal('show')}}>
                                    1. Quem cuida da refrigeração e climatização?
                                    </Link>
                                    
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="quemCuidaRefrigeraClima" onClick={() => setQuemCuidaRefrigeraClima('Equipe própria.')} checked={ quemCuidaRefrigeraClima == 'Equipe própria.' ? 1 : 0} />
                                        </center>
                                    </td>
                                    <td>
                                        Equipe própria.
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="quemCuidaRefrigeraClima" onClick={() => setQuemCuidaRefrigeraClima('Equipe terceirizada com contratos de médio e longo prazo.')} checked={ quemCuidaRefrigeraClima == 'Equipe terceirizada com contratos de médio e longo prazo.' ? 1 : 0}  />
                                        </center>
                                    </td>
                                    <td>
                                        Equipe terceirizada com contratos de médio e longo prazo.
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="quemCuidaRefrigeraClima" onClick={() => setQuemCuidaRefrigeraClima('Apenas sob demanda com contratos para serviços pontuais.')} checked={ quemCuidaRefrigeraClima == 'Apenas sob demanda com contratos para serviços pontuais.' ? 1 : 0}  />
                                        </center>
                                    </td>
                                    <td>
                                        Apenas sob demanda com contratos para serviços pontuais.
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="quemCuidaRefrigeraClima" onClick={() => setQuemCuidaRefrigeraClima('Esses serviços não são utilizados.')} checked={ quemCuidaRefrigeraClima == 'Esses serviços não são utilizados.' ? 1 : 0}  />
                                        </center>
                                    </td>
                                    <td>
                                        Esses serviços não são utilizados.
                                    </td>
                                    
                                </tr>
                                
     
                            </tbody>
                        </Table>

                        <br/>

                        <Table striped bordered hover>
                            
                            <tbody>
                                <tr>
                                    <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                                    <Link to='#' style={{ color: questao2 }} onClick={() => {setEnunciado('2. Como é a gestão de energia (energia elétrica e outras formas) na sua organização?');setSecaoEnunciado('Gestão de Energia & Eficiência Energética');window.$('#modalValidacao').modal('show')}}>
                                    2. Como é a gestão de energia (energia elétrica e outras formas) na sua organização?
                                    </Link>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="gestaoEnergia" onClick={() => setGestaoEnergia('Apenas pela organização e com o pagamento das faturas.')} checked={ gestaoEnergia == 'Apenas pela organização e com o pagamento das faturas.' ? 1 : 0} />
                                        </center>
                                    </td>
                                    <td>
                                        Apenas pela organização e com o pagamento das faturas.
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="gestaoEnergia" onClick={() => setGestaoEnergia('Pela organização, pagamento das faturas, acompanhamento interno dos valores e consumo; nenhum sistema de medição local (além do medidor da concessionária).')} checked={ gestaoEnergia == 'Pela organização, pagamento das faturas, acompanhamento interno dos valores e consumo; nenhum sistema de medição local (além do medidor da concessionária).' ? 1 : 0}  />
                                        </center>
                                    </td>
                                    <td>
                                        Pela organização, pagamento das faturas, acompanhamento interno dos valores e consumo; nenhum sistema de medição local (além do medidor da concessionária).
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="gestaoEnergia" onClick={() => setGestaoEnergia('Pela organização, pagamento das faturas, acompanhamento interno dos valores e consumo; com sistema de medição local (além do medidor da concessionária).')} checked={ gestaoEnergia == 'Pela organização, pagamento das faturas, acompanhamento interno dos valores e consumo; com sistema de medição local (além do medidor da concessionária).' ? 1 : 0}  />
                                        </center>
                                    </td>
                                    <td>
                                        Pela organização, pagamento das faturas, acompanhamento interno dos valores e consumo; com sistema de medição local (além do medidor da concessionária).
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="gestaoEnergia" onClick={() => setGestaoEnergia('Pela organização, pagamento das faturas, acompanhamento interno dos valores e consumo; com sistema de automação e controle.')} checked={ gestaoEnergia == 'Pela organização, pagamento das faturas, acompanhamento interno dos valores e consumo; com sistema de automação e controle.' ? 1 : 0}  />
                                        </center>
                                    </td>
                                    <td>
                                        Pela organização, pagamento das faturas, acompanhamento interno dos valores e consumo; com sistema de automação e controle.
                                    </td>
                                    
                                </tr>
                                
                                
     
                            </tbody>
                        </Table>


                        <br/>

                        <Table striped bordered hover>
                            
                            <tbody>
                                <tr>
                                    <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                                    <Link to='#' style={{ color: questao3 }} onClick={() => {setEnunciado('3. Quem faz essa gestão?');setSecaoEnunciado('Gestão de Energia & Eficiência Energética');window.$('#modalValidacao').modal('show')}}>
                                    3. Quem faz essa gestão?
                                    </Link>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="quemFazGestao" onClick={() => setQuemFazGestao('Equipe própria')} checked={ quemFazGestao == 'Equipe própria' ? 1 : 0} />
                                        </center>
                                    </td>
                                    <td>
                                        Equipe própria
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="quemFazGestao" onClick={() => setQuemFazGestao('Equipe terceirizada')} checked={ quemFazGestao == 'Equipe terceirizada' ? 1 : 0} />
                                        </center>
                                    </td>
                                    <td>
                                        Equipe terceirizada
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="quemFazGestao" onClick={() => setQuemFazGestao('Mista (própria e terceirizada)')} checked={ quemFazGestao == 'Mista (própria e terceirizada)' ? 1 : 0} />
                                        </center>
                                    </td>
                                    <td>
                                        Mista (própria e terceirizada)
                                    </td>
                                    
                                </tr>
                               
                                
     
                            </tbody>
                        </Table>


                        <br/>

                        <Table striped bordered hover>
                            
                            <tbody>
                                <tr>
                                    <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                                    <Link to='#' style={{ color: questao4 }} onClick={() => {setEnunciado('4. Existem uma Política de eficiência energética na instituição?');setSecaoEnunciado('Gestão de Energia & Eficiência Energética');window.$('#modalValidacao').modal('show')}}>
                                    4. Existem uma Política de eficiência energética na instituição?
                                    </Link>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="politicaEficiencia" onClick={() => setPoliticaEficiencia('Não')} checked={ politicaEficiencia == 'Não' ? 1 : 0}  />
                                        </center>
                                    </td>
                                    <td>
                                        Não
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="politicaEficiencia" onClick={() => setPoliticaEficiencia('Não, mas em desenvolvimento')} checked={ politicaEficiencia == 'Não, mas em desenvolvimento' ? 1 : 0}  />
                                        </center>
                                    </td>
                                    <td>
                                        Não, mas em desenvolvimento
                                    </td>
                                    
                                </tr>

                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="radio" name="politicaEficiencia" onClick={() => setPoliticaEficiencia('Sim, desenvolvida e implementada')} checked={ politicaEficiencia == 'Sim, desenvolvida e implementada' ? 1 : 0}  />
                                        </center>
                                    </td>
                                    <td>
                                        Sim, desenvolvida e implementada
                                    </td>
                                    
                                </tr>
                              
                              
                                
     
                            </tbody>
                        </Table>



                        <br/>

                        <Table striped bordered hover>
                            
                            <tbody>
                                <tr>
                                    <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                                    <Link to='#' style={{ color: questao4 }} onClick={() => {setEnunciado('5. Quais das seguintes medidas de eficiência energética estão em prática em sua instituição? Selecione todas que se aplicam.');setSecaoEnunciado('Gestão de Energia & Eficiência Energética');window.$('#modalValidacao').modal('show')}}>
                                    5. Quais das seguintes medidas de eficiência energética estão em prática em sua instituição? Selecione todas que se aplicam.
                                    </Link>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="checkbox" value={engajamentoColaboradores} onChange={event => setEngajamentoColaboradores(event.target.checked)} checked={ engajamentoColaboradores ? 1 : 0} />
                                        </center>
                                    </td>
                                    <td>
                                        Engajamento de colaboradores por meio de programas de conscientização e treinamento sobre práticas de eficiência energética.
                                    </td>
                                    
                                </tr>

                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="checkbox" value={auditoriasEnergeticas} onChange={event => setAuditoriasEnergeticas(event.target.checked)} checked={ auditoriasEnergeticas ? 1 : 0} />
                                        </center>
                                    </td>
                                    <td>
                                        Realização de auditorias energéticas internas regulares para identificar oportunidades de melhoria para redução do consumo de energia.
                                    </td>
                                    
                                </tr>

                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="checkbox" value={substituicaoLampadas} onChange={event => setSubstituicaoLampadas(event.target.checked)} checked={ substituicaoLampadas ? 1 : 0} />
                                        </center>
                                    </td>
                                    <td>
                                        Substituição de lâmpadas por similares mais econômicas (ex., LED).
                                    </td>
                                    
                                </tr>

                                
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="checkbox"  value={iluminacaoInteligente} onChange={event => setIluminacaoInteligente(event.target.checked)} checked={ iluminacaoInteligente ? 1 : 0} />
                                        </center>
                                    </td>
                                    <td>
                                        Utilização de sistemas de iluminação inteligente, como sensores de movimento e controle de iluminação por zona.​
                                    </td>
                                    
                                </tr>

                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="checkbox" value={retrofit} onChange={event => setRetrofit(event.target.checked)} checked={ retrofit ? 1 : 0} />
                                        </center>
                                    </td>
                                    <td>
                                        Retrofit/atualização de equipamentos visando aumento da eficiência energética.​
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="checkbox" value={conservacaoEnergia} onChange={event => setConservacaoEnergia(event.target.checked)} checked={ conservacaoEnergia ? 1 : 0}  />
                                        </center>
                                    </td>
                                    <td>
                                        Implementação de medidas de conservação de energia, como isolamento térmico e vedação de janelas.​
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="checkbox" value={adocaoPoliticas} onChange={event => setAdocaoPoliticas(event.target.checked)} checked={ adocaoPoliticas ? 1 : 0}   />
                                        </center>
                                    </td>
                                    <td>
                                        Adoção de políticas de compra de equipamentos com classificação energética mais eficiente.​
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="checkbox" value={investimentoAutogeracao} onChange={event => setInvestimentoAutogeracao(event.target.checked)} checked={ investimentoAutogeracao ? 1 : 0}   />
                                        </center>
                                    </td>
                                    <td>
                                        Investimento em autogeração a partir de fontes renováveis (ex., geração distribuída com sistemas fotovoltaicos conectados à rede elétrica).​
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="checkbox" value={gerenciamentoDemanda} onChange={event => setGerenciamentoDemanda(event.target.checked)} checked={ gerenciamentoDemanda ? 1 : 0}   />
                                        </center>
                                    </td>
                                    <td>
                                        Adoção de práticas de gerenciamento de demanda de energia para otimizar o uso de energia durante os períodos de pico.​
                                    </td>
                                    
                                </tr>
                                
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="checkbox" value={tecnologiasCogeracao} onChange={event => setTecnologiasCogeracao(event.target.checked)} checked={ tecnologiasCogeracao ? 1 : 0}   />
                                        </center>
                                    </td>
                                    <td>
                                        Utilização de tecnologias de cogeração (geração de energia elétrica e calor simultaneamente).​
                                    </td>
                                    
                                </tr>
                                
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="checkbox" value={consultoriasEspecializadas} onChange={event => setConsultoriasEspecializadas(event.target.checked)} checked={ consultoriasEspecializadas ? 1 : 0}  />
                                        </center>
                                    </td>
                                    <td>
                                        Parcerias com instituições de pesquisa ou consultorias especializadas em eficiência energética para desenvolver soluções personalizadas.​
                                    </td>
                                    
                                </tr>
                                
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="checkbox" value={implementacaoSistemas} onChange={event => setImplementacaoSistemas(event.target.checked)} checked={ implementacaoSistemas ? 1 : 0}  />
                                        </center>
                                    </td>
                                    <td>
                                        Implementação de sistemas de gestão de energia certificados (por exemplo, ISO 50001).​
                                    </td>
                                    
                                </tr>
                                
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="checkbox" value={outras} onChange={event => setOutras(event.target.checked)} checked={ outras ? 1 : 0}  />
                                        </center>
                                    </td>
                                    <td>
                                        Outras (especifique).​
                                        <input type="text" className="form-control" maxLength={255} value={outrasEspecifique} onChange={event => setOutrasEspecifique(event.target.value)} />
                                    </td>
                                    
                                </tr>
                                

                                
     
                            </tbody>
                        </Table>

                        <br/>


                        <Table striped bordered hover>
                            
                            <tbody>
                                <tr>
                                    <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                                    <Link to='#' style={{ color: questao6 }} onClick={() => {setEnunciado('6. Quais são os maiores desafios para implementar ações de eficiência energética?');setSecaoEnunciado('Gestão de Energia & Eficiência Energética');window.$('#modalValidacao').modal('show')}}>
                                    6. Quais são os maiores desafios para implementar ações de eficiência energética? Indique o grau de dificuldade em uma escala de 0 a 5, sendo 0 muito fácil e 5 muito difícil. ​
                                    </Link>

                                    </td>
                                </tr>

                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                            <select className="form-control" value={baixaRelevancia} onChange={event => setBaixaRelevancia(event.target.value)} >
                                                <option value="">[Selecione]</option>
				 		
                                                    <option value="0" >0</option>
                                                
                                                    <option value="1" >1</option>
                                                
                                                    <option value="2" >2</option>
                                                
                                                    <option value="3" >3</option>

                                                    <option value="4" >4</option>

                                                    <option value="5" >5</option>
                                                
                                                
                                            </select>
                                                
                                        </center>
                                    </td>
                                    <td>
                                        Baixa relevância do tema no planejamento estratégico.
                                    </td>
                                </tr>  



                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                            <select className="form-control" value={resistenciaInvestir} onChange={event => setResistenciaInvestir(event.target.value)} >
                                                <option value="">[Selecione]</option>
				 		
                                                    <option value="0" >0</option>
                                                
                                                    <option value="1" >1</option>
                                                
                                                    <option value="2" >2</option>
                                                
                                                    <option value="3" >3</option>

                                                    <option value="4" >4</option>

                                                    <option value="5" >5</option>
                                                
                                                
                                            </select>
                                                
                                        </center>
                                    </td>
                                    <td>
                                        Resistência em investir em serviços externos (consultorias, diagnóstico energético, gestão, etc.).​
                                    </td>
                                </tr>  

                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                            <select className="form-control" value={limitacaoInvestimento} onChange={event => setLimitacaoInvestimento(event.target.value)} >
                                                <option value="">[Selecione]</option>
				 		
                                                    <option value="0" >0</option>
                                                
                                                    <option value="1" >1</option>
                                                
                                                    <option value="2" >2</option>
                                                
                                                    <option value="3" >3</option>

                                                    <option value="4" >4</option>

                                                    <option value="5" >5</option>
                                                
                                                
                                            </select>
                                                
                                        </center>
                                    </td>
                                    <td>
                                        Limitação de investimento institucional apenas para atividades centrais para a instituição.​
                                    </td>
                                </tr>  

                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                            <select className="form-control"  value={ausenciaTime} onChange={event => setAusenciaTime(event.target.value)} >
                                                <option value="">[Selecione]</option>
				 		
                                                    <option value="0" >0</option>
                                                
                                                    <option value="1" >1</option>
                                                
                                                    <option value="2" >2</option>
                                                
                                                    <option value="3" >3</option>

                                                    <option value="4" >4</option>

                                                    <option value="5" >5</option>
                                                
                                                
                                            </select>
                                                
                                        </center>
                                    </td>
                                    <td>
                                        Ausência de um time interno dedicado, o que dificulta a gestão de planos de ação.​
                                    </td>
                                </tr>  

                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                            <select className="form-control"  value={faltaConhecimento} onChange={event => setFaltaConhecimento(event.target.value)} >
                                                <option value="">[Selecione]</option>
				 		
                                                    <option value="0" >0</option>
                                                
                                                    <option value="1" >1</option>
                                                
                                                    <option value="2" >2</option>
                                                
                                                    <option value="3" >3</option>

                                                    <option value="4" >4</option>

                                                    <option value="5" >5</option>
                                                
                                                
                                            </select>
                                                
                                        </center>
                                    </td>
                                    <td>
                                        Falta de conhecimento/capacitação da equipe interna.​
                                    </td>
                                </tr>  

                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                            <select className="form-control" value={dificuldadeDefinicao} onChange={event => setDificuldadeDefinicao(event.target.value)}  >
                                                <option value="">[Selecione]</option>
				 		
                                                    <option value="0" >0</option>
                                                
                                                    <option value="1" >1</option>
                                                
                                                    <option value="2" >2</option>
                                                
                                                    <option value="3" >3</option>

                                                    <option value="4" >4</option>

                                                    <option value="5" >5</option>
                                                
                                                
                                            </select>
                                                
                                        </center>
                                    </td>
                                    <td>
                                        Dificuldade na definição da abordagem e de metas.​
                                    </td>
                                </tr>  

                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                            <select className="form-control" value={barreirasOperacionais} onChange={event => setBarreirasOperacionais(event.target.value)} >
                                                <option value="">[Selecione]</option>
				 		
                                                    <option value="0" >0</option>
                                                
                                                    <option value="1" >1</option>
                                                
                                                    <option value="2" >2</option>
                                                
                                                    <option value="3" >3</option>

                                                    <option value="4" >4</option>

                                                    <option value="5" >5</option>
                                                
                                                
                                            </select>
                                                
                                        </center>
                                    </td>
                                    <td>
                                        Barreiras operacionais à adesão de medidas de eficiência energética.​
                                    </td>
                                </tr>  

                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                            <select className="form-control"  value={investimentoInicial} onChange={event => setInvestimentoInicial(event.target.value)} >
                                                <option value="">[Selecione]</option>
				 		
                                                    <option value="0" >0</option>
                                                
                                                    <option value="1" >1</option>
                                                
                                                    <option value="2" >2</option>
                                                
                                                    <option value="3" >3</option>

                                                    <option value="4" >4</option>

                                                    <option value="5" >5</option>
                                                
                                                
                                            </select>
                                                
                                        </center>
                                    </td>
                                    <td>
                                        Investimento inicial muito elevado.​
                                    </td>
                                </tr>  

                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                            <select className="form-control"  value={baixaPercepcao} onChange={event => setBaixaPercepcao(event.target.value)} >
                                                <option value="">[Selecione]</option>
				 		
                                                    <option value="0" >0</option>
                                                
                                                    <option value="1" >1</option>
                                                
                                                    <option value="2" >2</option>
                                                
                                                    <option value="3" >3</option>

                                                    <option value="4" >4</option>

                                                    <option value="5" >5</option>
                                                
                                                
                                            </select>
                                                
                                        </center>
                                    </td>
                                    <td>
                                        Baixa percepção sobre o potencial de retorno financeiro.​
                                    </td>
                                </tr>  

                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                            <select className="form-control"  value={baixaAdesao} onChange={event => setBaixaAdesao(event.target.value)}  >
                                                <option value="">[Selecione]</option>
				 		
                                                    <option value="0" >0</option>
                                                
                                                    <option value="1" >1</option>
                                                
                                                    <option value="2" >2</option>
                                                
                                                    <option value="3" >3</option>

                                                    <option value="4" >4</option>

                                                    <option value="5" >5</option>
                                                
                                                
                                            </select>
                                                
                                        </center>
                                    </td>
                                    <td>
                                    Baixa adesão interna dos funcionários à cultura de eficiência energética.​
                                    </td>
                                </tr>  

                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                            <select className="form-control"  value={receioInfringir} onChange={event => setReceioInfringir(event.target.value)}   >
                                                <option value="">[Selecione]</option>
				 		
                                                    <option value="0" >0</option>
                                                
                                                    <option value="1" >1</option>
                                                
                                                    <option value="2" >2</option>
                                                
                                                    <option value="3" >3</option>

                                                    <option value="4" >4</option>

                                                    <option value="5" >5</option>
                                                
                                                
                                            </select>
                                                
                                        </center>
                                    </td>
                                    <td>
                                        Receio de infringir questões legais ou regulatórias.​
                                    </td>
                                </tr>  

                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                            <select className="form-control"  value={dificuldadesLicitatorias} onChange={event => setDificuldadesLicitatorias(event.target.value)}  >
                                                <option value="">[Selecione]</option>
				 		
                                                    <option value="0" >0</option>
                                                
                                                    <option value="1" >1</option>
                                                
                                                    <option value="2" >2</option>
                                                
                                                    <option value="3" >3</option>

                                                    <option value="4" >4</option>

                                                    <option value="5" >5</option>
                                                
                                                
                                            </select>
                                                
                                        </center>
                                    </td>
                                    <td>
                                        Dificuldades licitatórias para contratação de serviços ou aquisição de equipamentos eficientes.​
                                    </td>
                                </tr>  

                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                            <select className="form-control" value={dificuldadeSelecao} onChange={event => setDificuldadeSelecao(event.target.value)}  >
                                                <option value="">[Selecione]</option>
				 		
                                                    <option value="0" >0</option>
                                                
                                                    <option value="1" >1</option>
                                                
                                                    <option value="2" >2</option>
                                                
                                                    <option value="3" >3</option>

                                                    <option value="4" >4</option>

                                                    <option value="5" >5</option>
                                                
                                                
                                            </select>
                                                
                                        </center>
                                    </td>
                                    <td>
                                        Dificuldade na seleção de fornecedores ou produtos adequados.​
                                    </td>
                                </tr>  

                            </tbody>

                        </Table>

                        <br/>

                        <Table striped bordered hover>
                            
                            <tbody>
                                <tr>
                                    <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                                    <Link to='#' style={{ color: questao7 }} onClick={() => {setEnunciado('7. Qual é o interesse da organização em implementar diferentes ações de eficiência energética?');setSecaoEnunciado('Gestão de Energia & Eficiência Energética');window.$('#modalValidacao').modal('show')}}>
                                    7. Qual é o interesse da organização em implementar diferentes ações de eficiência energética? Classifique cada ação com os seguintes valores: 0 - sem interesse, 1 - baixo interesse, 2 - médio interesse, 3 - alto interesse, 4 – já implementado​
                                    </Link>

                                    </td>
                                </tr>

                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                            <select className="form-control" value={medidasEficienciaBaixoInvestimento} onChange={event => setMedidasEficienciaBaixoInvestimento(event.target.value)} >
                                                <option value="">[Selecione]</option>
				 		
                                                    <option value="0" >0</option>
                                                
                                                    <option value="1" >1</option>
                                                
                                                    <option value="2" >2</option>
                                                
                                                    <option value="3" >3</option>

                                                    <option value="4" >4</option>

                                                
                                                
                                            </select>
                                                
                                        </center>
                                    </td>
                                    <td>
                                        Medidas de eficiência energética de baixo investimento e tempo de retorno imediato ou curto, com recursos próprios.​
                                    </td>
                                </tr>  

                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                            <select className="form-control" value={medidasEficienciaMedioInvestimento} onChange={event => setMedidasEficienciaMedioInvestimento(event.target.value)} >
                                                <option value="">[Selecione]</option>
				 		
                                                    <option value="0" >0</option>
                                                
                                                    <option value="1" >1</option>
                                                
                                                    <option value="2" >2</option>
                                                
                                                    <option value="3" >3</option>

                                                    <option value="4" >4</option>

                                                
                                                
                                            </select>
                                                
                                        </center>
                                    </td>
                                    <td>
                                        Medidas de eficiência Energética de Médio Investimento e tempo de retorno médio (meses a 1 ano), com recursos próprios.​
                                    </td>
                                </tr>  

                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                            <select className="form-control" value={medidasEficienciaAltoInvestimento} onChange={event => setMedidasEficienciaAltoInvestimento(event.target.value)}  >
                                                <option value="">[Selecione]</option>
				 		
                                                    <option value="0" >0</option>
                                                
                                                    <option value="1" >1</option>
                                                
                                                    <option value="2" >2</option>
                                                
                                                    <option value="3" >3</option>

                                                    <option value="4" >4</option>

                                                
                                                
                                            </select>
                                                
                                        </center>
                                    </td>
                                    <td>
                                    Medidas de Eficiência energética de alto investimento e tempo de retorno longo (anos), com recursos próprios.​
                                    </td>
                                </tr>  

                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                            <select className="form-control" value={implementacaoSolucoes} onChange={event => setImplementacaoSolucoes(event.target.value)}  >
                                                <option value="">[Selecione]</option>
				 		
                                                    <option value="0" >0</option>
                                                
                                                    <option value="1" >1</option>
                                                
                                                    <option value="2" >2</option>
                                                
                                                    <option value="3" >3</option>

                                                    <option value="4" >4</option>

                                                
                                                
                                            </select>
                                                
                                        </center>
                                    </td>
                                    <td>
                                        Implementação de soluções de autogeração (ex., fotovoltaica).​
                                    </td>
                                </tr>  
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                            <select className="form-control" value={implementacaoPolitica} onChange={event => setImplementacaoPolitica(event.target.value)} >
                                                <option value="">[Selecione]</option>
				 		
                                                    <option value="0" >0</option>
                                                
                                                    <option value="1" >1</option>
                                                
                                                    <option value="2" >2</option>
                                                
                                                    <option value="3" >3</option>

                                                    <option value="4" >4</option>

                                                
                                                
                                            </select>
                                                
                                        </center>
                                    </td>
                                    <td>
                                        Implementação de política energética dentro do planejamento estratégico.​
                                    </td>
                                </tr>  

                                

                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                            <select className="form-control" value={contratacaoEspecialista} onChange={event => setContratacaoEspecialista(event.target.value)} >
                                                <option value="">[Selecione]</option>
				 		
                                                    <option value="0" >0</option>
                                                
                                                    <option value="1" >1</option>
                                                
                                                    <option value="2" >2</option>
                                                
                                                    <option value="3" >3</option>

                                                    <option value="4" >4</option>

                                                
                                                
                                            </select>
                                                
                                        </center>
                                    </td>
                                    <td>
                                    Contratação de especialista na área de eficiência energética.​
                                    </td>
                                </tr>  
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                            <select className="form-control" value={contratacaoConsultoria} onChange={event => setContratacaoConsultoria(event.target.value)}  >
                                                <option value="">[Selecione]</option>
				 		
                                                    <option value="0" >0</option>
                                                
                                                    <option value="1" >1</option>
                                                
                                                    <option value="2" >2</option>
                                                
                                                    <option value="3" >3</option>

                                                    <option value="4" >4</option>

                                                
                                                
                                            </select>
                                                
                                        </center>
                                    </td>
                                    <td>
                                        Contratação de serviço de consultoria em eficiência energética.​
                                    </td>
                                </tr>  
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                            <select className="form-control" value={capacitacaoEquipe} onChange={event => setCapacitacaoEquipe(event.target.value)}  >
                                                <option value="">[Selecione]</option>
				 		
                                                    <option value="0" >0</option>
                                                
                                                    <option value="1" >1</option>
                                                
                                                    <option value="2" >2</option>
                                                
                                                    <option value="3" >3</option>

                                                    <option value="4" >4</option>

                                                
                                                
                                            </select>
                                                
                                        </center>
                                    </td>
                                    <td>
                                        Capacitação da equipe técnica atual em eficiência energética.​
                                    </td>
                                </tr>  
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                            <select className="form-control" value={programaComContrapartida} onChange={event => setProgramaComContrapartida(event.target.value)} >
                                                <option value="">[Selecione]</option>
				 		
                                                    <option value="0" >0</option>
                                                
                                                    <option value="1" >1</option>
                                                
                                                    <option value="2" >2</option>
                                                
                                                    <option value="3" >3</option>

                                                    <option value="4" >4</option>

                                                
                                                
                                            </select>
                                                
                                        </center>
                                    </td>
                                    <td>
                                        Participação em Programa de eficiência energética (PEE)* com contrapartida.​
                                    </td>
                                </tr>  
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                            <select className="form-control" value={programaSemContrapartida} onChange={event => setProgramaSemContrapartida(event.target.value)}  >
                                                <option value="">[Selecione]</option>
				 		
                                                    <option value="0" >0</option>
                                                
                                                    <option value="1" >1</option>
                                                
                                                    <option value="2" >2</option>
                                                
                                                    <option value="3" >3</option>

                                                    <option value="4" >4</option>

                                                
                                                
                                            </select>
                                                
                                        </center>
                                    </td>
                                    <td>
                                        Participação em Programa de eficiência energética (PEE)* sem contrapartida.​
                                    </td>
                                </tr>  
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                            <select className="form-control" value={programaCompras} onChange={event => setProgramaCompras(event.target.value)} >
                                                <option value="">[Selecione]</option>
				 		
                                                    <option value="0" >0</option>
                                                
                                                    <option value="1" >1</option>
                                                
                                                    <option value="2" >2</option>
                                                
                                                    <option value="3" >3</option>

                                                    <option value="4" >4</option>

                                                
                                                
                                            </select>
                                                
                                        </center>
                                    </td>
                                    <td>
                                     Participação em Programa de Compras Sustentáveis de equipamentos mais eficientes.​
                                    </td>
                                </tr>  
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                            <select className="form-control" value={terceirizacaoResp} onChange={event => setTerceirizacaoResp(event.target.value)} >
                                                <option value="">[Selecione]</option>
				 		
                                                    <option value="0" >0</option>
                                                
                                                    <option value="1" >1</option>
                                                
                                                    <option value="2" >2</option>
                                                
                                                    <option value="3" >3</option>

                                                    <option value="4" >4</option>

                                                
                                                
                                            </select>
                                                
                                        </center>
                                    </td>
                                    <td>
                                        Terceirização da responsabilidade de Geração de Frio (Cooling as a Service).​
                                    </td>
                                </tr>  
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                            <select className="form-control" value={iso50001} onChange={event => setIso50001(event.target.value)} >
                                                <option value="">[Selecione]</option>
				 		
                                                    <option value="0" >0</option>
                                                
                                                    <option value="1" >1</option>
                                                
                                                    <option value="2" >2</option>
                                                
                                                    <option value="3" >3</option>

                                                    <option value="4" >4</option>

                                                
                                                
                                            </select>
                                                
                                        </center>
                                    </td>
                                    <td>
                                        Implementação de programa de certificação ISO 50001.​
                                    </td>
                                </tr>  
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                            <select className="form-control" value={adocaoRDC} onChange={event => setAdocaoRDC(event.target.value)} >
                                                <option value="">[Selecione]</option>
				 		
                                                    <option value="0" >0</option>
                                                
                                                    <option value="1" >1</option>
                                                
                                                    <option value="2" >2</option>
                                                
                                                    <option value="3" >3</option>

                                                    <option value="4" >4</option>

                                                
                                                
                                            </select>
                                                
                                        </center>
                                    </td>
                                    <td>
                                    Adoção do RDC - Regime Diferenciado de Contratação - Contrato de Desempenho**.​
                                    </td>
                                </tr>  


                            </tbody>
                        </Table>


                    
                    <div className="col-md-12">
                        <div align="center">
                            <br/>
                            <button type="button" className="btn btn-info" onClick={() => salvaEnergia()} >Salvar</button>
                        </div>
                    </div>


                <StatusValidacaoSecao desafio="Energia" secaoCampo="secaoEficiencia" totalPendencias={totalPendencias} nomeDesafio="Desafio Energia" formulario_id={energia_id} secao="Energia & Eficiência Energética" adesao_institucional_id={adesao_institucional_id} ano={ano} />

        </div>

    )

}

export default GestaoEficiencia